import { Providers } from './linkConstants';

// Pattern matchers for known providers
const providerPatterns: { [key in Providers]?: RegExp[] } = {
    [Providers.YouTube]: [/^(?:www\.)?youtube\.com$/i, /^youtu\.be$/i, /^(?:www\.)?youtube-nocookie\.com$/i],
    [Providers.Vimeo]: [/^(?:www\.)?vimeo\.com$/i, /^player\.vimeo\.com$/i],
    [Providers.SoundCloud]: [/^(?:www\.)?soundcloud\.com$/i, /^(?:\w+\.)?soundcloud\.app\.goo\.gl$/i],
    [Providers.Loom]: [/^(?:www\.)?loom\.com$/i, /^(?:\w+\.)?loom\.app\.link$/i],
    [Providers.Wistia]: [/^(?:[\w-]+\.)?wistia\.com$/i, /^(?:[\w-]+\.)?wi\.st$/i, /^fast\.wistia\.net$/i],
};

/**
 * Attempt to detect provider from the URL
 */
export const detectProviderFromUrl = (url: string): string | undefined => {
    try {
        const { hostname } = new URL(url.toLowerCase());

        for (const [provider, patterns] of Object.entries(providerPatterns)) {
            if (patterns.some((pattern) => pattern.test(hostname))) {
                return provider;
            }
        }
    } catch (e) {
        // Do nothing
    }

    return;
};
